import React from 'react';
import { Card, Button, Header, Icon, Image, Container } from 'semantic-ui-react';
import { flattenToAppURL } from '@plone/volto/helpers';

const CardView = ({ data }) => {
  const {
    items = [],
    stackable = true,
    itemsPerRow = 3,
  } = data;

  if (!items.length) return null;

  const renderCard = (item, index) => {
    const imageUrl = item.image
      ? `${item.image}/@@images/image`
      : null;

    const linkUrl = item.link?.[0]?.['@id']
      ? flattenToAppURL(item.link[0]['@id'])
      : null;

    const layout = item.layoutStyle || 'classic';

    const handleOverlayClick = () => {
      if (linkUrl) window.location.href = linkUrl;
    };

    // icon & text
    if (layout === 'iconText') {
      return (
        <Card key={index} className="card-borderless">
          <div className="card-icon-section">
            <Icon
              name={item.iconName || 'shield alternate'}
              size="huge"
              circular
              className="card-main-icon"
            />
            {item.title && (<Header as="h3" textAlign="center">{item.title}</Header>)}
          </div>

          {item.subtitle && (<Card.Description textAlign="center">{item.subtitle}</Card.Description>)}
          {linkUrl && (
            <Card.Content extra textAlign="center">
              <a href={linkUrl} className="card-link">
                {item.linkText || 'Learn more'}
              </a>
            </Card.Content>)
          }
  
        </Card>
      );
    }

    // overlay
    if (layout === 'overlay') {
      return (
        <div key={index} className="ui fluid card ">
          <a
            onClick={handleOverlayClick}
            href={linkUrl || '#'}
            className="card-overlay-container"
          >
            {imageUrl && (
              <Image
                src={imageUrl}
                alt={item.title || ''}
                className="card-overlay-image"
              />
            )}

            <div className="card-overlay-text">
              {item.title && (
                <div className="card-overlay-title">{item.title}</div>
              )}
              {item.subtitle && (
                <div className="card-overlay-subtitle">{item.subtitle}</div>
              )}
            </div>
          </a>
        </div>
      );
    }



    // classic
    return (
      <Card key={index}>

        {imageUrl && (<Image src={imageUrl} wrapped ui={false} />)}

        <Card.Content>{item.title && (<Header as="h3">{item.title}</Header>)}
          {item.subtitle && (<Card.Description>{item.subtitle}</Card.Description>)}
        </Card.Content>

        {linkUrl && (
          <Card.Content extra>
            <Button
              as="a"
              href={linkUrl}
              primary
              size="small"
              content={item.linkText || 'Learn more'}
            />
          </Card.Content>
        )}
      </Card>
    );
  };

  return (
    <section className="card-group-block">
      <Container>
        <Card.Group
          stackable={stackable}
          itemsPerRow={itemsPerRow}
        >
          {items.map(renderCard)}
        </Card.Group>
      </Container>
    </section>
  );
};

export default CardView;
